export enum OrderType {
  Normal = "Normal",
  Expedition = "Expedition"
}

export const ORDER_TYPE_OPTIONS = [
  { label: "All types", value: "" },
  { label: "Normal", value: OrderType.Normal },
  { label: "Expedition", value: OrderType.Expedition }
];
